import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CheckBoxModule } from 'app/shared/components/check-box/check-box.module';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { SelectObjectsTableComponent } from './select-objects-table.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    ScrollViewModule,
    PaginationModule,
    ButtonModule,
    TooltipModule,
    CheckBoxModule,
    BlockModalDragModule,
  ],
  declarations: [SelectObjectsTableComponent],
  exports: [SelectObjectsTableComponent],
})
export class SelectObjectsTableModule {}
